import styled from 'styled-components';

export const BannerLoaderContainer = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    margin-top:${props.theme.spacing.large.l20};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    box-shadow: 0 3px 30px 0  ${props.theme.colors.black.light1};
`,
);

export const BannerLoaderOuterWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-itmes: center;
    justify-content: space-between;
    padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l40};
    flex-direction: column;
`,
);

export const OfferHeadTextLoader = styled.div(
  props => `
    width: 30%;
    height: 4rem;
    font-size: 3.5rem;
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `
);

export const OfferBlockLoader = styled.div(
  props => `
    width:100%;
    display: flex;
    align-itmes: center;
    justify-content: space-between;
    padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.nospacing};
  `
)

export const BannerLoaderInnerWrap = styled.div(
  props => `
    display:flex;
    margin-right: ${props.theme.spacing.large.l20};
  `,
);

export const OfferImageLoader = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    border-radius:${props.theme.misc.borderRadius.small};
    margin-bottom :${props.theme.spacing.base};
  `,
);

export const OfferImageLoaderFirst = styled(OfferImageLoader)`
  width: 2rem;
  height: 12rem;
  margin-top: 3rem;
  border-radius: 0.6rem 0rem 0rem 0.6rem;
`;

export const OfferImageLoaderSecond = styled(OfferImageLoader)`
  width: 15rem;
  height: 15rem;
  border-radius: 0.6rem 0.6rem 0rem 0rem;
`;

export const OfferImageLoaderThird = styled(OfferImageLoader)`
  width: 19rem;
  height: 12rem;
  margin-top: 3rem;
  border-radius: 0rem 0.6rem 0.6rem 0rem;
`;
